export const getCookie = function(cookiename){
    let arr,
        reg = new RegExp('(^| )'+cookiename+"=([^;]*)(;|$)");
    if(!document.cookie) return '';
    if(arr = document.cookie.match(reg)){
        return decodeURIComponent(arr[2])
    }else{
        return '';
    }
}